const TaxModes = Object.freeze({
  CALCULATED_TAX: 'CALCULATEDTAX',
  VAT: 'VAT',
});

export {TaxModes};
